namespace Matrix.Indexation {
    export interface DimIndexationProfileRow {
        IndexationProfileKey?: number;
        DateKey?: string;
        ArchivedBy?: string;
        ArchivedWhen?: string;
        IndexationProfileCode?: string;
        Name?: string;
        IndexationInstanceId?: string;
        EffectiveDate?: string;
        ValidFrom?: string;
        ValidTo?: string;
        ShortName?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
    }

    export namespace DimIndexationProfileRow {
        export const idProperty = 'IndexationProfileKey';
        export const localTextPrefix = 'Indexation.DimIndexationProfile';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            IndexationProfileKey = "IndexationProfileKey",
            DateKey = "DateKey",
            ArchivedBy = "ArchivedBy",
            ArchivedWhen = "ArchivedWhen",
            IndexationProfileCode = "IndexationProfileCode",
            Name = "Name",
            IndexationInstanceId = "IndexationInstanceId",
            EffectiveDate = "EffectiveDate",
            ValidFrom = "ValidFrom",
            ValidTo = "ValidTo",
            ShortName = "ShortName",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder"
        }
    }
}
